import axios from 'axios';

import { AXIOS_CONFIG } from './constants';

export const requestInstance = axios.create(AXIOS_CONFIG);
